export default __webpack_public_path__ + "static/media/shark-label-3.93fc1b95.gif";